<template>
	<nk-page :body-class="'nk-page-body-without-scroll'" :buttons="footerPageButtons()" commercialAccess="System" :policyClaims="['Accounting_Document_List']">
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="h-100 d-flex flex-column form-container overflow-auto">
			<div class="nk-card">
				<div class="row mx-0 mb-2">
					<div class="col-12 col-sm-5">
						<nk-col-form-group :label="$t('document.document-selector.select-period') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9, xs: 12 }">
							<nk-dropdown ref="docSelectorSelectPeriod" v-model="selectedFiscal" :data="fiscalPeriods()" :options="componentOptions.fiscalPeriod" :tabindex="100"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-5">
						<nk-col-form-group :label="$t('document.document-selector.date-range') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9, xs: 12 }">
							<nk-dropdown ref="docSelectorDateRange" :options="componentOptions.dateRange" v-model="selectedDateRange" :tabindex="101" :data="dateRanges"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-2 text-center">
						<nk-button :tabindex="102" class="" :options="componentOptions.btnLoad" @click="getDocumentsList" ref="btnLoad"></nk-button>
					</div>
				</div>
				<div class="row mb-2" v-if="selectedDateRange && selectedDateRange.key == 'CustomRange'">
					<div class="col-12 col-sm-5">
						<nk-col-form-group :label="$t('reports.start-date') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }">
							<nk-date ref="reportsStartDate" :options="componentOptions.date" v-model="startDate" :tabindex="103"></nk-date>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-5">
						<nk-col-form-group :label="$t('reports.end-date') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }">
							<nk-date ref="reportsEndDate" :options="componentOptions.date" v-model="endDate" :tabindex="104"></nk-date>
						</nk-col-form-group>
					</div>
				</div>
			</div>
			<div class="h-grow-lock pt-3">
				<ag-grid :options="componentOptions.tableOption" :data="documents" :key="updateTable" v-model="selectedRow" ref="docsList" tabindex="105" startup class="nk-card" @row_db-clicked="rowDbClicked" @preSelectedRowData="rowClicked"></ag-grid>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import { post } from '~/plugins/nikan-api'
	import $sc from '~/plugins/shortcut.collection.js'
	import Endpoints from '@nikan/endpoints'
	import PersianDate from 'persian-date'
	import { mapGetters, mapState, mapActions } from 'vuex'
	import ChangeLog from '~/components/form/change-log/change-log.vue'
	import DocumentSettings from '~/views/settings/settings-document'
	import DocumentSingle from '~/views/documents/document-single'
	import PreviewContainer from '~/components/form/preview-container'
	import { findRoute } from '~/statics/routes'
	import { PrintDataConvertTypes } from '@/plugins/stimul'
	import UpdateCode from '@/components/form/salary/personnel/update-code.vue'
	import _ from 'lodash'
	import { FormModes } from '@/enums/system'
	import dialog from '~/plugins/nikan-dialog-plugin'

	export default {
		name: 'document-selector',
		modal: {
			size: 'lg',
			stateUID: 'document-selector',
			helpTag: 'DocumentList'
		},
		props: {
			options: { type: Object },
			data: { type: Object },
		},
		data() {
			return {
				updateTable: 0,
				tableRendered: null,
				settings: {
					selectablePeriod: true,
					multiselection: true,
					selectedRow: null
				},
				documents: [],
				originalDocuments: [],
				dateRanges: null,
				selectedRow: null,
				singleSelectedRow: null,
				selectedFiscal: null,
				selectedDateRange: null,
				startDate: null,
				endDate: null,
				selectAsCopy: false,
				componentOptions: {
					tableOption: {
						id: this.$options.name,
						// pagination: true,
						groupIncludeTotalFooter: false,
						enterToSelect: true,
						rowSelection: {
							mode: 'multiRow',
							checkboxes: true,
							headerCheckbox: true
						},
						keepSelectionOrder: true,
						columnDefs: [
							{
								field: 'code',
								headerName: this.$t('document.f.document-code'),
								contentType: 'number',
								width: 100,
								sort: 'desc',
								aggFunc: 'count'
							},
							{
								field: 'attachNumber',
								headerName: this.$t('document.f.attachNumber'),
								contentType: 'number',
								width: 100,
							},
							{
								field: 'prevCode',
								headerName: this.$t('document.f.prevCode'),
								contentType: 'number',
								width: 100,
								hide: true
							},
							{
								field: 'date',
								headerName: this.$t('document.f.date'),
								contentType: 'date',
								sort: 'desc',
								width: 100,
							},
							{
								field: 'sumDebits',
								headerName: this.$t('document.f.sumDebits'),
								contentType: 'price',
								width: 100,
							},
							{
								field: 'sumCredits',
								headerName: this.$t('document.f.sumCredits'),
								contentType: 'price',
								width: 100,
							},
							{
								field: 'description',
								headerName: this.$t('document.f.description'),
								contentType: 'string',
							},
							{
								field: 'codeInReports',
								headerName: this.$t('document.f.codeInReports'),
								contentType: 'number',
								valueFormatter: data => {
									return data.value ? data.value : ''
								},
								width: 100,
							},
							{
								field: 'system',
								headerName: this.$t('document.system.name'),
								contentType: 'enum',
								valueFormatter: data => {
									return data.value ? this.$t(`document.system.${data.value.toLowerCase()}`) : ''
								},
							},
							{
								field: 'user',
								headerName: this.$t('document.f.user'),
								contentType: 'enum',
								valueFormatter: data => {
									return data.value ? data.value : ''

								},
							},
							{
								field: 'created',
								headerName: this.$t('Auditable.Created'),
								contentType: 'date',

								valueFormatter: data => {
									if (data.value) {
										var date = new PersianDate(data.value)
										return date.format('YYYY-MM-DD HH:mm:ss')
									}
									return ''

								},
							},
							{
								field: 'lastModified',
								headerName: this.$t('Auditable.LastModified'),
								contentType: 'date',

								valueFormatter: data => {
									if (data.value) {
										var date = new PersianDate(data.value)
										return date.format('YYYY-MM-DD HH:mm:ss')
									}
									return ''

								},
							},
							{
								field: 'type',
								headerName: this.$t('document.f.type'),
								contentType: 'enum',
								valueFormatter: data => {
									return data.value || ''
								},
							},
						]
					},

					fiscalPeriod: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return item.name
						},
						searchableFields: ['name'],
					},
					dateRange: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return this.$t(item.group + '.' + item.key.toLowerCase())
						},
						searchableFields: ['key'],
					},
					btnLoad: {
						title: this.$t('load'),
						shortcut: $sc.find('search'),
						isPrimary: false,
						icon: '',
						handle: () => {
							this.getDocumentsList()
						}
					},
				},
				excelButton: {
					type: 'excel',
					mapSettings: { type: 'Document', successHandler: this.getDocumentsList, hasProgress: true },
					module: 'system',
					exportIds: () => this.isObject(this.selectedRow) ? [this.selectedRow.id] : this.selectedRow.map(x => x.id),
				},
				printButton: {
					type: 'print',
					claimPrefix: 'Accounting_Document_List',
					form: 'DocumentList',
					getDataSources: this.print_dataSources,
					disabled: true,
				},
				groupPrintButton: {
					buttonOptions: {
						title: this.$t('sale.factor-list.f.multiplePrint'),
						shortcut: { keyCode: 79, ctrlKey: true },

					},
					preHandler: () => {
						if (!this.selectedRow.length) {
							this.$toast(this.$t('no-case-selected', { type: this.$t('EntityTypes.DocumentHeader') }))
							return false
						} else if (this.selectedRow.length > 100) {
							this.$toast(this.$t('sale.factor.m.no-more-than-rows', { number: 100 }))
							return false
						}
						return true

					},

					type: 'print',
					claimPrefix: 'Accounting_Document_List',
					form: 'Document',
					isBulk: true,
					getDataSources: this.groupPrintDocument,
					disabled: false,
				},
				selectDocumentButton: {
					title: this.$t('select'),
					shortcut: $sc.find('enter-only'),
					icon: 'check',
					element: () => this.$refs.docsList.$el,
					isPrimary: true,
					handle: (button, page, e) => {

						if (_.isEmpty(this.singleSelectedRow))
							return this.$toast(this.$t('document.m.select-row'))

						this.resolve(this.singleSelectedRow)
					},
					policyClaims: 'Accounting_Document_List',
				},
				buttons_refresh: {
					title: this.$t('trs.chq.oper.refresh'),
					icon: 'sync',
					handle: () => {
						this.getDocumentsList()
					},
				},
				button_change_log: {
					title: this.$t('change-log.f.change-log'),
					handle: (button, page, e) => {
						this.getChangeLog()
					},
					icon: 'scroll',
					policyClaims: 'General_ChangeLog_List',
				},
				settings_button: {
					title: this.$t('setting.documentSettings.title'),
					handle: (button, page, e) => {
						this.showModal({
							component: DocumentSettings,
						}).then((res) => { })
							.catch(() => { })
					},
					icon: 'cog',
					policyClaims: 'Settings_Accounting_Document',
				},
				addButton: {
					title: this.$t('new'),
					shortcut: $sc.find('new'),
					icon: 'plus',
					isPrimary: false,
					handle: () => {
						this.showModifyDocument()
					},
					policyClaims: 'Accounting_Document_Add',
				},
				editDocumentButton: {
					title: this.$t('edit'),
					shortcut: $sc.find('edit'),
					visible: true,
					icon: 'edit',
					handle: (button, page, e) => {
						e.preventDefault()
						if (_.isEmpty(this.selectedRow))
							return this.$toast(this.$t('document.operations.no-document-selected'), { type: 'info' })

						this.showModifyDocument(this.selectedRow[0])
					},
					policyClaims: 'Accounting_Document_Edit',
				},
				deleteBulkButton: {
					title: this.$t('delete'),
					shortcut: $sc.find('delete'),
					visible: true,
					icon: 'trash',
					handle: (button, page, e) => {
						e.preventDefault()
						if (_.isEmpty(this.selectedRow))
							return this.$toast(this.$t('document.operations.no-document-selected'), { type: 'info' })

						this.showDeleteDialog()
					},
					policyClaims: 'Accounting_Document_Delete',
				},
				previewButton: {
					title: this.$t('document.form-buttons.show-preview-source'),
					shortcut: $sc.find('view-document'),
					icon: 'file-import',
					isPrimary: false,
					visible: true,
					handle: (button, page, e) => {
						if (_.isEmpty(this.selectedRow))
							return this.$toast(this.$t('document.operations.no-document-selected'), { type: 'info' })

						this.showPreviewSource(this.selectedRow[0])
					}
				},
				previewDocumentButton: {
					title: this.$t(`view-document`),
					shortcut: $sc.find('view-document'),
					visible: true,
					icon: 'fal fa-file-alt',
					handle: (button, page, e) => {
						e.preventDefault()
						this.previewDocument()
					},
				},
				changeCodeButton: {
					title: this.$t('document.f.change-code'),
					isPrimary: false,
					icon: 'code',
					handle: (button, page, e) => { this.changeDocumentCode() },
					policyClaims: { or: ['Accounting_Document_Edit'] },
				},
				maxPrintCenterLevel: 1,
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)

					if (!this.settings.multiselection) {
						this.componentOptions.tableOption.multiselection = false
						this.componentOptions.tableOption.checkboxesEnabled = false
					}

				},
			},
		},
		computed: {
			...mapGetters({
				fiscalPeriods: 'fiscalPeriods/getByCompanyId',
				getParentByLevel: 'accounts/getParentByLevel',

			}),
			...mapState('appContext', {
				status: (state) => state,
			}),
		},
		mounted() {

			let buttonsArray
			if (this.grandParentType() === 'modal')
				buttonsArray = [this.selectDocumentButton]
			else
				buttonsArray = [
					this.addButton,
					this.editDocumentButton,
					this.deleteBulkButton,
					this.excelButton,
					this.printButton,
					this.groupPrintButton,
					this.previewButton,
					this.previewDocumentButton,
					this.changeCodeButton,
				]

			this.prepareWindow(this.$t('document.documents-list'), buttonsArray)

			this.settings = _.merge({}, this.settings, this.options)

			if (!this.settings.multiselection) {
				this.componentOptions.tableOption.multiselection = false
				this.componentOptions.tableOption.checkboxesEnabled = false
			}

			if (this.settings.selectedRow && this.settings.selectedRow.id)
				this.selectedRow = this.settings.selectedRow

			if (this.status && this.status.fiscalPeriod)
				this.selectedFiscal = this.status.fiscalPeriod

			this.getProperties()
			this.getDocumentsList()

			this.componentOptions.tableOption.rowSelection.mode = this.grandParentType() === 'modal' ? 'singleRow' : 'multiRow'

		},
		methods: {
			...mapActions({
				broadcastItemExist: 'socket/broadcastItemExist',
			}),
			showPreviewSource(document) {
				if (!document.sourceEntityType) {
					this.$toast(this.$t('document.m.has-no-source'))
					return
				}


				this.showModal({
					component: PreviewContainer,
					data: null,
					options: { entityType: document.sourceEntityType, entityId: document.sourceEntityId },
				}).then(() => { }).catch(() => {

				})
			},
			showModifyDocument(document = null) {
				const route = findRoute('accounting.document.document-issue')

				if (document)
					route.data = document
				this.$openTab(route)
			},
			showDeleteDialog() {
				if (this.selectedRow?.length < 1)
					return this.$toast(this.$t('document.m.select-row'))

				if (this.selectedRow.some(x => x.system !== 'Accounting')) {
					return this.$toast(this.$t('document.delete-bulk.cant-delete-from-subsystem'))
				}

				dialog({
					title: this.$t('document.delete-bulk.title'),
					body: this.$t('document.delete-bulk.body', { count: this.selectedRow.length }),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteDocumentBulk()
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteDocumentBulk() {
				post(Endpoints.getUrl('documents.bulk-delete'), { documentHeaderIds: this.selectedRow.map(x => x.id) }).then((res) => {
					dialog({
						title: this.$t('document.delete-bulk.title'),
						body: `${res.data.succeeded.length ? this.$t('document.delete-bulk.success', { codes: res.data.succeeded.map(x => x.code).join(', ') }) + '<br /><br />' : ''}
						${res.data.failed.length ? this.$t('document.delete-bulk.failed') + ':<br />' : ''}
						 ${res.data.failed.map(x => `${x.code}: ${x.errorMessage}`).join('<br />')}`,
						buttons: [
							{
								title: this.$t('dialog.seen'),
								shortcut: $sc.find('cancel', 'dialog'),
								isPrimary: true,
								handle: (button, page, e) => {
									if (res.data.succeeded.length)
										this.getDocumentsList()
								}
							},
						],
					})
				})
			},
			prepareAggregateDocumentData(document) {
				const prepareGroupedAccounts = () => {
					for (let detail of data.details) {
						let kol = null
						if (detail.account.level <= 2)
							kol = detail.account
						else
							kol = this.getParentByLevel(detail.account.id, 2)

						let group = groupedAccount.find(x => x.account.id === kol.id)
						if (group)
							group.details.push(detail)
						else
							groupedAccount.push({ account: kol, details: [detail] })
					}
				}
				const fillDebits = (groupAccount, sumDebits) => {
					debits.push({
						rowNumber: '',
						account: groupAccount.account.name,
						accountingCode: groupAccount.account.accountingCode,
						centers: '',
						detailPrice: '',
						debit: sumDebits,
						credit: '',
						description: '',
						rowType: 'kol'
					})
					debits.push(...groupAccount.details.filter(x => x.currencyValues[0].debit > 0).map(x => {
						return {
							rowNumber: '',
							account: x.account.name,
							accountingCode: x.account.accountingCode,
							centers: x.centers?.map(x => x.name).join(', '),
							detailPrice: x.currencyValues[0].debit,
							debit: '',
							credit: '',
							description: x.description,
							rowType: 'joz'
						}
					}))
				}
				const fillCredits = (groupAccount, sumCredits) => {
					credits.push({
						rowNumber: '',
						account: groupAccount.account.name,
						accountingCode: groupAccount.account.accountingCode,
						centers: '',
						detailPrice: '',
						debit: '',
						credit: sumCredits,
						description: '',
						rowType: 'kol'
					})
					credits.push(...groupAccount.details.filter(x => x.currencyValues[0].credit > 0).map(x => {
						return {
							rowNumber: '',
							account: x.account.name,
							accountingCode: x.account.accountingCode,
							centers: x.centers?.map(x => x.name).join(', '),
							detailPrice: x.currencyValues[0].credit,
							debit: '',
							credit: '',
							description: x.description,
							rowType: 'joz'
						}
					}))
				}
				const setRowNumbers = () => {
					let rowNumber = 1
					for (let item of data.details) {
						if (item.rowType === 'kol')
							item.rowNumber = rowNumber++
					}
				}
				let data = document
				let groupedAccount = []
				let debits = []
				let credits = []
				prepareGroupedAccounts()
				for (let groupAccount of groupedAccount) {
					let sumDebits = _.sumBy(groupAccount.details, detail => {
						return Number(detail.currencyValues[0].debit)
					})
					let sumCredits = _.sumBy(groupAccount.details, detail => {
						return Number(detail.currencyValues[0].credit)
					})
					if (sumDebits !== 0) {
						fillDebits(groupAccount, sumDebits)
					}
					if (sumCredits !== 0) {
						fillCredits(groupAccount, sumCredits)
					}
				}
				data.rows = [...debits, ...credits]
				setRowNumbers()
				return data
			},

			async groupPrintDocument() {
				var wait = this.$wait(this.$el, { size: 'small' })
				let items = []
				await post(Endpoints.getUrl('documents.fullData'), { ids: this.selectedRow.map(x => x.id) }, null, {
					// silent: true,
				})
					.then((result) => {
						items = result.data.items
					})
					.catch((err) => {
						return err
					})

				wait.end()

				const DocumentSingle = (await import('@/views/documents/document-single.vue')).default

				return {
					items: items,
					preparer: (item) => DocumentSingle.methods.print_dataSources.apply(this, [item])
				}
			},
			print_dataSources() {
				const data = this.$refs.docsList.getFilteredTableData()


				return [
					{
						name: 'Document',
						data: data,
						translatedDataSetName: this.$t('nav.document'),
						translatePrefix: 'document.f',
						converter: {
							type: PrintDataConvertTypes.MAPPER,
							settings: {
								code: 'code',
								attachNumber: 'attachNumber',
								date: 'date',
								system: (item, row) => this.$t(`badges.system.${item.toLowerCase()}`),
								sumCredits: 'sumCredits',
								sumDebits: 'sumDebits',
								user: 'user.userName',
								description: 'description'
							}
						},
					}
				]
			},
			footerPageButtons() {
				if (this.settings?.mode === 'readonly' || this.grandParentType() === 'modal') return []
				var button_array = [
					this.buttons_refresh,
					this.button_change_log,
					this.settings_button
				]
				return button_array
			},
			getChangeLog() {
				let entityTitle
				if (this.selectedRow[0]?.id) {
					entityTitle = this.$t('change-log.f.document-log-title', {
						code: this.selectedRow[0]?.code.toLocaleDigits(),
					})
				} else {
					entityTitle = this.$t('change-log.f.documents-log-title')
				}
				this.showModal({
					component: ChangeLog,
					options: {
						entityId: this.selectedRow[0]?.id ? this.selectedRow[0]?.id : null,
						entityType: 'DocumentHeader',
						entityTitle: entityTitle,
					},
				})
					.then((node) => { })
					.catch(() => { })

			},
			previewDocument(selectedRow) {
				if (selectedRow || this.selectedRow.length === 1) {
					this.showModal({
						component: DocumentSingle,
						options: { id: this.selectedRow[0]?.id || this.selectedRow[0].documentId, fiscalPeriodId: this.selectedRow[0]?.fiscalPeriodId }
					})
						.then((response) => {
							this.submit()
						})
						.catch(() => {
						})
				} else {
					this.$toast(this.$t('document.m.select-row'), { type: 'info' })
				}
			},
			getDocumentsList() {
				let request = {}

				if (this.settings.documentGroup)
					request.documentGroup = this.settings.documentGroup

				if (this.selectedFiscal) request.fiscalPeriodId = this.selectedFiscal.id
				if (this.selectedDateRange) request.dateRange = this.selectedDateRange.key
				if (this.startDate) request.startDate = this.startDate
				if (this.endDate) request.endDate = this.endDate

				var wait = this.$wait(this.$refs.docsList.$el)
				post(Endpoints.getUrl('documents.list-for-selector'), request)
					.then((result) => {
						wait.end()
						this.documents = result.data.items
						this.originalDocuments = _.cloneDeep(this.documents)

						if (this.documents && this.documents.length)
							this.printButton.disabled = false

						this.updateTable++
						if (this.data && this.data.isNew === false) {
							this.selectedRow = this.data
						} else {
							this.selectedRow = this.documents[0]
						}
					})
					.catch(() => {
						wait.end()
					})
			},
			getProperties() {
				this.dateRanges = this.getPropertiesByGroup('DateRanges')
				this.selectedDateRange = (this.dateRanges || []).find(
					(x) => x.key === 'SevenDays'
				)
			},
			rowClicked(val) {
				this.singleSelectedRow = val
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			},
			changeDocumentCode() {
				if (this.selectedRow.length !== 1)
					return this.$toast(this.$t('document.m.select-row'))

				this.showModal({
					component: UpdateCode,
					options: {
						claim: 'Accounting_Document_Edit',
						commercialAccess: 'System',
						reviewComponent: 'DocumentSingle',
						componentOptions: { mode: FormModes.READONLY, hideFooterButtons: true }
					},
					data: { ...this.originalDocuments.find(x => x.id === this.selectedRow[0].id), type: null, user: null }
				}).then(res => {
					const wait1 = this.$wait(this.$el)
					post(Endpoints.getUrl('documents.update'), { documentHeader: res, forceUpdateCode: true }).then((result) => {
						this.broadcastItemExist({ form: this.$t('document.document'), code: result.data.savedDocumentNumber })
						this.$toast(this.$t('document.m.save.success', { docCode: result.data.savedDocumentNumber }), { type: 'success' })
						this.getDocumentsList()
					}).finally(() => {
						wait1.end()
					})
				}).catch(err => { }).finally(() => {
				})
			},
			subscribeKeys() {
				// this.$keyHandler.Subscribe({
				// name: 'select-document',
				// keyCode: 13,
				// ctrlKey: true,
				// el: this.$refs.docsList.$el,
				// context: this,
				// handler: function (sender, e) {
				// if (_.isEmpty(this.selectedRow))
				// return this.$toast(this.$t('document.m.select-row'))
				// this.resolve(this.selectedRow)
				// return true
				// },
				// })
			}
		},
	}
</script>
